

































import Vue from 'vue';
import { SaveMessageState } from '../../lib/enums/saveMessage';
import { mapGetters, mapState, mapMutations } from 'vuex';
export default Vue.extend({
  name: 'NavSaveIndicator',
  props: {
    namespace: { type: String, required: true }
  },
  data() {
    return {
      SaveMessageState
    };
  },
  computed: {
    ...mapState({
      saveMessageState(state) {
        return state['components'][this.namespace].saveMessageState;
      }
    })
  },
  methods: {
    ...mapMutations({
      setSaveMessageState(commit, payload) {
        return commit(
          'components/' + this.namespace + '/setSaveMessageState',
          payload
        );
      }
    }),
    saveStateChanged() {
      this.onSaveCompleteTimeOut && clearTimeout(this.onSaveCompleteTimeOut);
      if (this.saveMessageState == SaveMessageState.Saved) {
        this.setSaveCompleteTimeOut();
      }
    },
    setSaveCompleteTimeOut() {
      this.onSaveCompleteTimeOut = setTimeout(() => {
        if (this.saveMessageState == SaveMessageState.Saved)
          this.setSaveMessageState({ saveMessageState: SaveMessageState.None });
      }, 3000);
    }
  },
  watch: {
    saveMessageState: 'saveStateChanged'
  }
});
